// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 925 ? "2c386607" : chunkId) + "." + {"678":"cbc8f5752fe92769","925":"41606329b69f6915"}[chunkId] + ".js";
};